import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LegalEntityEprocessiRiferimentoResult } from '../../models/data.model';
import { DataService } from '../../services/data.service';
import { CommonService } from '../../services/common.service';
import { EqualtecService } from '../../services/equaltec.service';
import { LegalEntityService } from 'src/app/services/legal-entity.service';
@Component({
  selector: 'app-equaltec-topbar',
  templateUrl: './EqualtecTopbar.component.html'
})

export class EqualtecTopbar implements OnInit {

  @ViewChild('Or') OrElement: any;
  @ViewChild('And') AndElement: any;

  public changeLegalEntityButton: boolean = true;
  public listLegalEntity: string[] = [];
  public isDetail: boolean = false;
  public isFavorites: boolean = false;
  public isEvidence: boolean = false;
  public isSearch: boolean = false;
  private subDetail: any;
  private subFavorites: any;
  private subEvidence: any;
  private subSearch: any;

  constructor(
    public translate: TranslateService,
    public equaltecService: EqualtecService,
    private legalEntityService: LegalEntityService,
    private dataService: DataService,
    private processoRiferimentoService: CommonService<LegalEntityEprocessiRiferimentoResult>,
  ) { }

  ngOnInit(): void {
    this.subDetail = this.equaltecService.isDetail.subscribe(val => {
      this.isDetail = val
    });
    this.subFavorites = this.equaltecService.isFavorites.subscribe(val => {
      this.isFavorites = val
    });
    this.subEvidence = this.equaltecService.isEvidence.subscribe(val => {
      this.isEvidence = val
    });
    this.subSearch = this.equaltecService.isSearch.subscribe(val => {
      this.isSearch = val
    });
    this.caricaLegalEntityEProcessidiRiferimento();
    // Questo è veramente un casino:
    // quanto viene caricato service-ita.component tramite il routing personale del modulo, si inserisce nel dataService il nome del titolo del componente
    // a questo ComponentInput si sottoscrive il padre di di service-ita, cioè custom-layout.component, che renderizza il titolo in alto
    this.dataService.ComponentInput = '';
  }

  changeLegalEntityButtonMethod = () => {
    this.changeLegalEntityButton = !this.changeLegalEntityButton;
  }

  changeLegalEntity = () => {
    this.caricaLegalEntityEProcessidiRiferimento(); // La legal entity scelta dall'utente è nell'input della post
  }

  caricaLegalEntityEProcessidiRiferimento() {
    const url = 'api/rest/CaricaLegalEntityEProcessidiRiferimento';
    const input = {
      legalEntity: this.equaltecService.selectedLegalEntity
    };
    this.processoRiferimentoService.postData(url, input, false).subscribe(result => {
      if (result) {
        const resultLegalEntityEprocessiRiferimentoResult = result as LegalEntityEprocessiRiferimentoResult;
        this.listLegalEntity = resultLegalEntityEprocessiRiferimentoResult.legalEntities;
        this.equaltecService.processi = resultLegalEntityEprocessiRiferimentoResult.processiRiferimentoDto;
        this.equaltecService.selectedLegalEntity = resultLegalEntityEprocessiRiferimentoResult.legalEntitiesSelected;
        this.equaltecService.isCompliance = this.legalEntityService.isLegalEntityCompliance(this.equaltecService.selectedLegalEntity);
        if (this.equaltecService.isCompliance) {
          this.equaltecService.openCompliance();
        }
        this.equaltecService.processiSopra = this.equaltecService.processi.filter(d => d.posizione === 1 && !this.legalEntityService.isProcessoCompliance(d));
        this.equaltecService.processiCentrale = this.equaltecService.processi.filter(d => d.posizione === 2 && !this.legalEntityService.isProcessoCompliance(d));
        this.equaltecService.processiSotto = this.equaltecService.processi.filter(d => d.posizione === 3 && !this.legalEntityService.isProcessoCompliance(d));
      }
    }, error => console.error('error on get Processi di Riferimento', error));
  }

  isFilterFunc() {
    this.equaltecService.openSearch()
  }

  ngOnDestroy() {
    this.subDetail.unsubscribe()
    this.subFavorites.unsubscribe();
    this.subEvidence.unsubscribe();
    this.subSearch.unsubscribe();
  }

}
